import { GoalType } from '@griply/types';
import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { useOpenCreateProjectDialog } from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useTheme } from 'styled-components';

export const AddProjectButton: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const openPremiumDialog = useOpenPremiumDialog();
  const openCreateProjectDialog = useOpenCreateProjectDialog();
  const { allowed: createProjectAllowed } = useCreateUnlimitedGoalsAllowed(
    GoalType.Project,
  );

  const onAdd = () =>
    createProjectAllowed ? openCreateProjectDialog() : openPremiumDialog();

  return theme.isMobile ? null : (
    <Button
      onClick={onAdd}
      size={Sizes.Small}
      variant={Variants.Contained}
      color={Colors.Primary}
      preventDrag
    >
      {t('general.new-project')}
    </Button>
  );
};
